import { render, staticRenderFns } from "./grossing-touch-sidebar.vue?vue&type=template&id=5540c40b&scoped=true&"
import script from "./grossing-touch-sidebar.ts?vue&type=script&lang=ts&"
export * from "./grossing-touch-sidebar.ts?vue&type=script&lang=ts&"
import style0 from "./grossing-touch-sidebar.scss?vue&type=style&index=0&id=5540c40b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5540c40b",
  null
  
)

export default component.exports